import { AuthFailure, NetworkError } from './errors.js';
export const DEFAULT_TIMEOUT_MS = 20_000;
async function call(fetchImpl, url, init, timeoutMs) {
    const ctl = new AbortController();
    const timer = setTimeout(() => ctl.abort(), timeoutMs);
    let res;
    try {
        res = await fetchImpl(url, { ...init, signal: ctl.signal });
    }
    catch (e) {
        throw new NetworkError(e instanceof Error && e.name === 'AbortError'
            ? 'The server took too long to answer'
            : 'Could not reach the server');
    }
    finally {
        clearTimeout(timer);
    }
    if (res.status === 401 || res.status === 403) {
        const body = (await res.json().catch(() => ({})));
        throw new AuthFailure(body.code ?? 'unauthenticated', body.error ?? 'Not allowed');
    }
    if (res.status >= 500 || res.status === 408 || res.status === 429)
        throw new NetworkError(`Server error ${res.status}`);
    if (!res.ok) {
        const body = (await res.json().catch(() => ({})));
        throw new Error(body.error ?? `Request failed (${res.status})`);
    }
    return (await res.json());
}
export function httpTransport(baseUrl = '', fetchImpl = fetch, timeoutMs = DEFAULT_TIMEOUT_MS) {
    const auth = (token) => ({ authorization: `Bearer ${token}` });
    return {
        push: (token, req) => call(fetchImpl, `${baseUrl}/api/sync/push`, {
            method: 'POST',
            headers: { 'content-type': 'application/json', ...auth(token) },
            body: JSON.stringify(req),
        }, timeoutMs),
        pull: (token, since, limit) => call(fetchImpl, `${baseUrl}/api/sync/pull?since=${encodeURIComponent(since)}${limit ? `&limit=${limit}` : ''}`, { headers: auth(token) }, timeoutMs),
    };
}
export function loginOnline(input, baseUrl = '', fetchImpl = fetch, timeoutMs = DEFAULT_TIMEOUT_MS) {
    return call(fetchImpl, `${baseUrl}/api/auth/login`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(input),
    }, timeoutMs);
}
//# sourceMappingURL=transport.js.map